export default {
    create() {
        let splash = game.add.sprite(0, 0, 'title');
        splash.inputEnabled = true;
        splash.input.useHandCursor = true;
        let next = () => {
            game.input.keyboard.onDownCallback = undefined;
            game.add.tween(game.world)
                .to({ alpha: 0 }, 100, null, true)
                .onComplete
                .add(() => game.state.start("play"));
        };
        splash.events.onInputUp.addOnce(next);
        game.input.keyboard.enabled = true;
        game.input.keyboard.onDownCallback = next;

        if (typeof ga === "function") ga('send', 'event', 'game', 'menu');
    },

    shutdown() {

    }
};


// WEBPACK FOOTER //
// ./src/states/menu.js